import React from "react";
import PropTypes from "prop-types";
import { map, partial } from "ramda";

import { withTracking } from "helpers/analytics";

import Button from "components/button";
import CreditCard from "components/account/credit_cards/credit_card";
import EditCreditCard from "components/account/credit_cards/edit_credit_card";

import {
  isolateDisplayableCards,
  findCardByCardUuid,
} from "helpers/credit_cards";

function CreditCardList({
  creditCardList,
  storeInfo,
  onCreditCardCancel,
  onUpdateCreditCardField,
  onCreditCardRemove,
  onCreditCardSave,
  onToggleForm,
  onCreateNewLocalCard,
  onSaveNewCreditCard,
  onCancelNewCardRecord,
  onBlurValidateCCField,
  onReturnCardErrors,
  onSaveNewCreditCardWithToken,
}) {
  // Make sure to exclude any temporary copies we have created
  const cardList = isolateDisplayableCards(creditCardList);

  const accountCards = map(
    card => (
      <CreditCard
        key={`${card.type}-${card.lastFour}`}
        card={card}
        handleToggleForm={onToggleForm}
        handleSaveCard={onCreditCardSave}
        handleRemoveCard={onCreditCardRemove}
        handleUpdateCardField={onUpdateCreditCardField}
        handleCancelCardUpdates={onCreditCardCancel}
      />
    ),
    cardList
  );

  let newCardState;
  const newCard = findCardByCardUuid("new-card", creditCardList);
  // If a card with id 'new-card', exists at all we know that the form
  // must be shown.
  if (newCard) {
    newCardState = (
      <EditCreditCard
        card={newCard}
        storeInfo={storeInfo}
        onCancel={onCancelNewCardRecord}
        onUpdateCard={partial(onSaveNewCreditCard, [newCard])}
        onReturnCardErrors={onReturnCardErrors}
        onUpdateCreditCardField={onUpdateCreditCardField}
        onBlurValidateCCField={onBlurValidateCCField}
        onSaveNewCreditCardWithToken={onSaveNewCreditCardWithToken}
      />
    );
  } else {
    newCardState = (
      <Button
        type="text"
        onClick={withTracking(
          onCreateNewLocalCard,
          "OLO - Account - click add new credit card"
        )}>
        + Add new card
      </Button>
    );
  }

  return (
    <div className="account-section card-list-wrapper">
      <h3>Credit card information</h3>
      <ul className="card-list">{accountCards}</ul>
      {newCardState}
    </div>
  );
}

CreditCardList.propTypes = {
  creditCardList: PropTypes.array.isRequired,
  storeInfo: PropTypes.object,
  onToggleForm: PropTypes.func.isRequired,
  onCreditCardCancel: PropTypes.func.isRequired,
  onUpdateCreditCardField: PropTypes.func.isRequired,
  onBlurValidateCCField: PropTypes.func.isRequired,
  onReturnCardErrors: PropTypes.func.isRequired,
  onCreditCardRemove: PropTypes.func.isRequired,
  onCreditCardSave: PropTypes.func.isRequired,
  onCreateNewLocalCard: PropTypes.func.isRequired,
  onSaveNewCreditCard: PropTypes.func.isRequired,
  onCancelNewCardRecord: PropTypes.func.isRequired,
  onSaveNewCreditCardWithToken: PropTypes.func.isRequired,
};

export default CreditCardList;
